import { getSolViewProps } from '@/helpers/solution'

function getInitialState() {
  const res = {}
  return res
}

const getters = {
  sol_view_viewProps: (state, getters) =>
    getSolViewProps({
      sol_data_updated: getters.sol_data_updated,
      sol_data_street: getters.sol_data_street,
      sol_detail_player: getters.sol_detail_player,
      sol_data_players: getters.sol_data_players,
      sol_elite_is_using: getters.sol_elite?.is_using,
      showHandValue: getters.mergedUserSettings.showHandValue,
      sw_tabs_study: getters.sw_tabs_study,
      sw_tabs_strategy: getters.sw_tabs_strategy,
      sw_hand_content: getters.sw_hand_content,
      sw_range_height: getters.sw_range_height,
      sw_combos_columns: getters.sw_combos_columns,
      sw_combos_chart_style: getters.sw_combos_chart_style,
      // TODO: rm after 3way rls
      sw_range_content_opponent: getters.sw_range_content_opponent,
      sw_range_content_hero: getters.sw_range_content_hero,
    }),
}

const mutations = {
  sol_view_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state: getInitialState(),
  getters,
  mutations,
}
